import { useQuery } from '@tanstack/react-query';
import { getGeneralMetaData } from '@/entities/meta-data/meta-data.api';
import { metaDataQueryKeys } from '@/entities/meta-data/meta-data.keys';

export const useGeneralMetaDataQuery = (options = {}) =>
  useQuery({
    queryKey: metaDataQueryKeys.general,
    queryFn: getGeneralMetaData,
    ...options,
  });
